module.exports = __webpack_public_path__ + "assets/img/f600f6b8d2a56b75b3acb68b4bfc3f3d.png";